import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAdminAxiosInstance } from "../../../../api/Admin";

const initialState = {
  currentPage: 1,
  currentPageSize: 10,
  currentFilter: "all",
  sortBy: "",
  sortOrder: "desc",
  search: "",
  isEdit: false,
  showCreateModal: false,
  showDeleteModal: false,
  clearSelection: false,
  selectedId: "",
  showPassword: false,
  placeholderData: {},
  editPlaceholderData: {},
  error: "",
  statusData: {},
  isLoading: false,
};

export const getPlaceholderEditData = createAsyncThunk(
  "/search/edit",
  async (id, { rejectWithValue }) => {
    const api = await getAdminAxiosInstance();
    try {
      const response = await api.get(`/search/edit?search_id=${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const placeholderSlice = createSlice({
  name: "placeholder",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPlaceholderEditData.pending, (state, action) => {
        // state.isLoading = true;
      })
      .addCase(getPlaceholderEditData.fulfilled, (state, action) => {
        state.editPlaceholderData = action.payload?.data;
        // state.isLoading = false;
      })
      .addCase(getPlaceholderEditData.rejected, (state, action) => {
        // state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { updateConfig } = placeholderSlice.actions;
export default placeholderSlice.reducer;
